import { BaseError } from '../../errors/baseError';

export class NonEmptyStringError extends BaseError {
  constructor(value: string) {
    super('non_empty_string', `Expected a non-empty string, got ${value}`);
  }
}
